import { publicApi } from '../lib/api'

export type ProfileGiftRow = {
  id: number
  from_person: {
    handle: string
    display_name: string
    avatar_url: string
  }
  amount_pixe: number
  amount_pixe_atomic: string
  post: {
    id: number
    title: string
    slug: string
  } | null
  created_at: string
}

export type ProfileGiftsResponse = {
  results: ProfileGiftRow[]
  page: number
  page_size: number
  count: number
}

export async function getProfileGifts(
  handle: string,
  page = 1,
  pageSize = 25,
  q?: string
): Promise<ProfileGiftsResponse> {
  const { data } = await publicApi.get<ProfileGiftsResponse>(`/api/people/${encodeURIComponent(handle)}/gifts/`, {
    params: { page, page_size: pageSize, q: q?.trim() || undefined },
  })
  return data
}
